export const parsePricingLogTag = (tag: string | undefined): string => {
  if (!tag) return "CUSTOM QUOTE"

  const [termAndPurpose, loanTypeCode] = tag.split("_")
  const loanTerm = termAndPurpose.slice(0, -1)
  let loanPurpose: string

  if (termAndPurpose.endsWith("p")) {
    loanPurpose = "PURCHASE"
  } else if (termAndPurpose.endsWith("co")) {
    loanPurpose = "REFI CO"
  } else {
    loanPurpose = "REFI"
  }

  return `${loanTerm}YR ${loanTypeCode.toUpperCase()} ${loanPurpose}`
}
